import { IOvertimeRequestState } from '@/store/overtime-request';
import { IOvertimeRequestMutations } from './mutations.types';
import {
  IMentionAttachmentCommentData,
  IOvertimeRequestData,
  IUserData
} from '@/models';
import { ITransition } from '@/models/transition';

export const mutations: IOvertimeRequestMutations = {
  SET_COUNT(state: IOvertimeRequestState, payload: number): void {
    state.count = payload;
  },

  INCREMENT_COUNT(state: IOvertimeRequestState): void {
    state.count += 1;
  },

  DECREMENT_COUNT(state: IOvertimeRequestState): void {
    state.count -= 1;
  },

  SET_OVERTIME_REQUESTS(
    state: IOvertimeRequestState,
    payload: IOvertimeRequestData[]
  ): void {
    state.overtimeRequests = payload;
  },

  ADD_OVERTIME_REQUEST(
    state: IOvertimeRequestState,
    payload: IOvertimeRequestData
  ): void {
    state.overtimeRequests.unshift(payload);
  },

  UPDATE_OVERTIME_REQUEST(
    state: IOvertimeRequestState,
    payload: IOvertimeRequestData
  ): void {
    const index = state.overtimeRequests.findIndex(
      (overtime: IOvertimeRequestData) => overtime.id === payload.id
    );

    state.overtimeRequests.splice(index, 1, payload);
  },

  REMOVE_OVERTIME_REQUEST(state: IOvertimeRequestState, payload: number): void {
    const index = state.overtimeRequests.findIndex(
      (overtime: IOvertimeRequestData) => overtime.id === payload
    );

    state.overtimeRequests.splice(index, 1);
  },

  SET_OVERTIME_REQUEST_ACTIVITIES(
    state: IOvertimeRequestState,
    payload: ITransition[]
  ): void {
    state.activities = payload;
  },

  SET_OVERTIME_REQUEST_COMMENTS(
    state: IOvertimeRequestState,
    payload: IMentionAttachmentCommentData[]
  ): void {
    state.comments = payload;
  },

  ADD_OVERTIME_REQUEST_COMMENT(
    state: IOvertimeRequestState,
    payload: IMentionAttachmentCommentData
  ): void {
    state.comments.unshift(payload);
  },

  UPDATE_OVERTIME_REQUEST_COMMENT(
    state: IOvertimeRequestState,
    payload: IMentionAttachmentCommentData
  ): void {
    const index = state.comments.findIndex(
      (comment: IMentionAttachmentCommentData) => comment.id === payload.id
    );

    state.comments.splice(index, 1, payload);
  },

  REMOVE_OVERTIME_REQUEST_COMMENT(
    state: IOvertimeRequestState,
    payload: number
  ): void {
    const index = state.comments.findIndex(
      (comment: IMentionAttachmentCommentData) => comment.id === payload
    );

    state.comments.splice(index, 1);
  },

  SET_LAST_CREATED_OVERTIME_REQUEST_COMMENT_ID(
    state: IOvertimeRequestState,
    payload: number
  ): void {
    state.lastCreatedOvertimeRequestCommentId = payload;
  },

  SET_MENTIONABLE_USERS(
    state: IOvertimeRequestState,
    payload: IUserData[]
  ): void {
    state.mentionableUsers = payload;
  },

  SET_LAST_PROMISE(state: IOvertimeRequestState, payload: Promise<any>): void {
    state.lastPromise = payload;
  }
};
